import { SchoolWithoutTeachers } from "./schoolWithoutTeachers";
import { Teacher } from "./teacher";

export const getSchoolsQueryKey = () => ["schools"];

export const getSchoolQueryKey = (id: number) => ["school", id];

export interface School extends SchoolWithoutTeachers {
    teachers: Teacher[];
}
